export enum Orientation {
  Landscape = "landscape",
  Portrait = "portrait",
}
